import React from "react";
import TooltipIcon from "assets/tooltip.svg";
import { Tooltip } from "./Tooltip";

interface InfoTooltipProps {
  name: string;
  tooltip: React.ReactNode;
}

export const InfoTooltip: React.FC<InfoTooltipProps> = props => {
  return (
    props.tooltip && <>
      <span className={props.name} style={{cursor:'pointer'}}><TooltipIcon /></span>
      <Tooltip target={`.${props.name}`} content={props.tooltip} />
    </>
  );
};
